<template>

    <div class="container">

        <div class="handle-box-search">





            <el-row class="head-search">


                <el-col :span="24" style="margin-bottom: 10px;">
                    <span class="title">起止时间:</span>

                    <el-date-picker v-model="search_time" type="daterange" range-separator="-" start-placeholder="开始日期"
                                    end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" @change="timeChange"
                                    style="width: 300px;">
                    </el-date-picker>
                </el-col>

                <el-col :span="24" style="margin-bottom: 10px;">
                    <span class="title">优惠券:</span>

                    <el-select
                    
                            v-model="value_coupon_code"
                            placeholder="请选择优惠券"
                            @visible-change="couponList"
                            @change="couponChange"
                            clearable
                            filterable
                            style="position: relative"
                    >
                        <el-option
                                v-for="item in options_coupon_code"
                                :key="item.value"
                                :label="item.name"
                                :value="item.coupon_mode_code"
                        >
                        </el-option>

                        <selectPages
                                :search_data="coupon_options_data"
                                :result_data="selectPages_coupon_data"
                                @selectPages_function="selectPages_coupon_function"
                        ></selectPages>

                    </el-select>
                </el-col>


            </el-row>

            <el-button type="primary" icon="el-icon-search" @click="searchcheckCarCardLists">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button :icon="!progress_show?'el-icon-setting':'el-icon-loading'" @click="toExport" :disabled="progress_show">{{progress_show?'正在导出...':'导出'}}</el-button>
        </div>

        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">

            <el-table-column prop="billno" label="订单号">
            </el-table-column>
            <el-table-column prop="name" label="司机姓名">
            </el-table-column>

            <el-table-column prop="phone" label="司机电话">
            </el-table-column>


            <el-table-column prop="consumer_name" label="乘客姓名">
            </el-table-column>



            <el-table-column prop="consumer_phone" label="乘客电话">
            </el-table-column>

            <el-table-column prop="amount" label="实际金额">
            </el-table-column>

            <el-table-column prop="finish_amount" label="实收金额">
            </el-table-column>

            <el-table-column prop="full_price" label="满减条件">
            </el-table-column>

            <el-table-column prop="sub_price" label="满减金额">
            </el-table-column>

            <el-table-column prop="bear_price" label="司机承担金额">
            </el-table-column>
            <el-table-column prop="order_date" label="下单时间">
            </el-table-column>

            <el-table-column prop="end_date" label="完成时间">
            </el-table-column>

            



        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>


    </div>

</template>

<script>
    var _this;
    export default {


        data() {
            return {


                search_time: '',

                // 存放表格数据
                tableData: [],

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                    fixed_array: '',
                    coupon_mode_code:''
                },

                options_coupon_code:[],
                coupon_options_data: {
                    page: 1,
                    limit: 5
                },
                value_coupon_code:'',
                selectPages_coupon_data:[],

                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    },

                },


                excelData: [],

                excelHead: [],

                progress_show: false,
            };
        },
        created() {
            _this = this;
        },

        methods: {
            toExport(){
                _this.search_data.page = 1;
                
                _this.getExcelData();
                
            },
            // 导出excel方法
            exportData() {
                const {
                    export_json_to_excel
                } = require('@/vendor/Export2Excel');
                const tHeader = ['订单号','司机姓名','司机电话', '乘客姓名', '乘客电话', '实际金额', '实收金额', '满减条件', '满减金额', '司机承担金额', '下单时间', '完成时间'];
                const filterVal = ['billno','name','phone','consumer_name','consumer_phone','amount','finish_amount','full_price','sub_price','bear_price','order_date','end_date'];
                const list = this.excelData;
                const data = this.formatJson(filterVal, list);
                export_json_to_excel(tHeader, data, 'fileName');
            },

            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            getExcelData(){
                
                _this.$post(
                    "/statistics/getOrderCouponLists",
                    _this.search_data
                ).then(res => {

                    _this.progress_show = true;

                    if (this.$route.path == '/getOrderCouponLists') {


                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.length; i++) {

                            _this.excelData.push({
                                'billno': res.data[i].billno,
                                'name': res.data[i].name,
                                'phone': res.data[i].phone,
                                'consumer_name': res.data[i].consumer_name,
                                'consumer_phone': res.data[i].consumer_phone,
                                'amount': res.data[i].amount,
                                'finish_amount': res.data[i].finish_amount,
                                'full_price': res.data[i].full_price,
                                'sub_price': res.data[i].sub_price,
                                'bear_price': res.data[i].bear_price,
                                'end_date': res.data[i].end_date,
                                'order_date': res.data[i].order_date,

                            });


                        }
                        



                        if (_this.search_data.page * _this.search_data.limit < res.count) {

                            _this.search_data.page = _this.search_data.page + 1;
                            
                            

                            _this.getExcelData();

                        } else {

                            // console.log(_this.excelData);

                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;


                        }

                    } else {

                        _this.progress_show = false;

                    }



                }).catch((err) => {

                })

            },

            selectPages_coupon_function(search_data) {
                _this.coupon_options_data = search_data;

                _this.couponList();
            },

            couponChange(val) {
                _this.search_data.coupon_mode_code = val;
            },
            couponList() {
                _this
                    .$post('/coupon/CouponModeLists', _this.coupon_options_data)
                    .then((res) => {
                        _this.selectPages_coupon_data = res;
                        _this.options_coupon_code = res.data;
                    })
                    .catch((err) => {});
            },
            timeChange(val) {
                if(val !== null){
                    _this.search_data.fixed_array = JSON.stringify(['between'].concat(val));

                }else{
                    _this.search_data.fixed_array = ''
                }

            },
            searchcheckCarCardLists() {


                _this.search_data.page = 1;
                _this.checkCarCardLists();

            },
            // 搜索司机日志列表
            checkCarCardLists() {
                if(_this.search_data.fixed_array == ''){
                    _this.$message.error('请选择起止时间')
                    return;
                }
                _this.$post(
                    "/statistics/getOrderCouponLists",
                    _this.search_data,
                    _this.search_rules
                )
                    .then(res => {


                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;

                    }).catch((err) => {

                })
            },
            //翻页组件的回调
            pages_function(search_data) {

                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.checkCarCardLists();

            },


            // 刷新按钮
            refresh() {
                this.$router.go(0);
            },

        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-form-item.el-form-item--small {
        width: 100%;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
    }

    .el-form-item__content span {
        display: inline-block;
        width: 100%;
        word-wrap: break-word;
        white-space: normal;
    }
</style>
